module.exports = __webpack_public_path__ + "files/982cb33deecdb32e87bae6da059e84f4.png";